import React from 'react';
import ReactMarkdown, { type Components } from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize from 'rehype-sanitize';
import remarkGfm from 'remark-gfm';
import { FilesService } from '@/services/FilesService';
import { attachmentDownloadPath, stripAccessTokens } from './chatAttachmentLinks';

interface ChatMessageMarkdownProps {
    content: string;
}

const downloadAttachment = (path: string) => {
    // Ошибку FilesService уже показал тостом; здесь только гасим отказ промиса.
    FilesService.downloadFile(path).catch(() => {});
};

const remarkPlugins = [remarkGfm];
const rehypePlugins = [rehypeRaw, rehypeSanitize];

/* Объект и тип ссылки — общие для всех сообщений: новый `a` на рендер перемонтировал бы каждую ссылку ленты. */
const components: Components = {
    a: ({ node, children, ...props }) => {
        // react-markdown passes `node`; keep it out of DOM props.
        void node;

        const downloadPath = attachmentDownloadPath(props.href);
        if (downloadPath) {
            // Вложение качаем через $api с Bearer: прямой переход по ссылке ушёл бы без авторизации.
            const onDownload = (event: React.MouseEvent<HTMLAnchorElement>) => {
                if (event.type === 'auxclick' && event.button !== 1) return;
                event.preventDefault();
                downloadAttachment(downloadPath);
            };
            return (
                <a {...props} href={props.href} rel="noopener noreferrer" onClick={onDownload} onAuxClick={onDownload}>
                    {children}
                </a>
            );
        }

        return (
            <a {...props} target="_blank" rel="noopener noreferrer">
                {children}
            </a>
        );
    },
};

/** Разбор markdown — только при смене текста: лента перерисовывается на статус, ввод и ответы. */
const ChatMessageMarkdown = React.memo(function ChatMessageMarkdown({ content }: ChatMessageMarkdownProps) {
    return (
        <div className="ai-form-markdown">
            <ReactMarkdown remarkPlugins={remarkPlugins} rehypePlugins={rehypePlugins} components={components}>
                {stripAccessTokens(content)}
            </ReactMarkdown>
        </div>
    );
});

export default ChatMessageMarkdown;
